<template>
  <div>
    <div class="row">
      <div class="w-100 position-relative" v-if="loading">
        <div class="w-100 mt-5 position-absolute text-center">
          <b-icon class="text-light" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
        </div>
      </div>
      <div class="w-100 text-center mt-3 bg-dark p-5 rounded" v-else>
        <h3>TOTAL STOCK VALUE</h3>
        <span class="total text-success font-weight-bold">{{Math.round(data.totalMinPrice).toLocaleString('no') || 0}} PLN</span>
      </div>
      <div v-if="data.uniqueProducts" class="col p-3 mt-3 mr-3 rounded font-weight-bold text-center bg-primary text-white">
        <p>UNIQUE PARTS IN STOCK</p>
        <h3>{{data.uniqueProducts.toLocaleString('en')}}</h3>
      </div>
      <div v-if="data.totalLocalCount" class="col p-3 mt-3 rounded font-weight-bold text-center bg-primary text-white">
        <p>TOTAL PARTS COUNT IN STOCK</p>
        <h3>{{data.totalLocalCount.toLocaleString('en')}}</h3>
      </div>
    </div>
    <div v-if="history.length" class="row mt-5">
      <b-col class="text-center bg-dark mb-3 p-3 rounded">
        <h3>Stock history - last 30 weeks</h3>
      </b-col>
      <b-table class="text-center" striped hover :items="history" :fields="historyFields"></b-table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import fixed from '../../fixed';

export default {
  name: 'TotalStock',
  data: () => ({
    loading: false,
    data: {
      totalMinPrice: 0,
      uniqueProducts: 0,
      totalLocalCount: 0,
    },
    history: [],
    historyFields: [
      { key: 'recordedAt', formatter: (value) => moment(value).format('DD.MM.yyyy HH.mm') },
      { key: 'uniqueProducts', label: 'Unique', formatter: (value) => value.toLocaleString('no') || 0 },
      { key: 'totalLocalCount', label: 'Total Count', formatter: (value) => value.toLocaleString('no') || 0 },
      {
        key: 'totalMinPrice',
        label: 'Total Stock Value PLN',
        formatter: (value) => Math.round(value).toLocaleString('no') || 0,
      },
    ],
  }),
  async mounted() {
    this.loading = true;

    try {
      // Get total current
      const { data } = await axios.get(
        `${fixed.API_URL}/admin/total-stock-value`,
        { withCredentials: true },
      );

      const [result] = data || {};
      this.data = result;

      // Get history
      const { data: history } = await axios.get(
        `${fixed.API_URL}/admin/stock-history`,
        { withCredentials: true },
      );
      if (history && history.length) this.history = history;
    } catch (error) {
      console.error(error); // eslint-disable-line
    }
    this.loading = false;
  },
  methods: {
  },
};
</script>

<style scoped>
.total {
  font-size: 2.5rem;
}
</style>
